module.exports = __webpack_public_path__ + "AvertaCyrillic-Regular.c234e69ddb0fe60eef5b.ttf";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/fonts/AvertaCyrillic-Regular.ttf
// module id = ../../../../../src/assets/fonts/AvertaCyrillic-Regular.ttf
// module chunks = styles